import React, { useEffect } from 'react';
import { device_fields } from '../constants/create_device_fields';
import CustomInput from '../../../../components/CustomInput';
import { Button, Typography } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';
import service from '../service';

import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBoundStore } from '../../../../stores';

function CreateDeviceDrawer() {
  const [deviceFormData, setDeviceFormData] = React.useState({
    imei: '',
    description: '',
    barcodeNumber: '',
    description: '',
    deviceModel: '',
    version: '',
    status: 'ACTIVE',
  });

  const navigate = useNavigate();

  const [vehicles, setVehicles] = React.useState([]);
  const [filterData, setFilterData] = React.useState({ query: '' });
  const [vehicle, setVehicle] = React.useState({});
  const [currentMatch, setCurrentMatch] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [sortModel, setSortModel] = React.useState([]);
  const { hash } = useLocation();

  const toggleLeftDrawer = useBoundStore((state) => state.toggleLeftDrawer);

  const getDevice = async () => {
    const response = await service.getDeviceByBarcodeNumber({
      barcodeNumber: hash.split('#')[1]
    });
    const deviceData = response?.data;
    setDeviceFormData(() => ({
      ...deviceData,
      imei: deviceData?.imei || '',
      description: deviceData?.description || '',
      barcodeNumber: deviceData?.barcodeNumber || '',
      deviceModel: deviceData?.deviceModel || '',
      version: deviceData?.version || '',
      status: deviceData?.status || '',
    }));
  };

  const handleUpdate = async () => {
    // console.log(deviceFormData);
    await service.updateDevice({
      deviceId: deviceFormData.id,
      data: deviceFormData,
    }).then((response) => {
      if (response?.status === 200 || response?.status === 201) {
        toast.success('Cihaz başarıyla güncellendi.');
      } else {
        toast.error('Cihaz güncellenirken bir hata oluştu.');
      }
      navigate('/definitions/devices');
      toggleLeftDrawer();
    });
  };


  useEffect(() => {
    getDevice();
  }, [hash]);

  return (
    <div className="mt-5">
      <div className="px-2">
        <Typography variant="h6">Cihaz Güncelle</Typography>
      </div>
      <div>
        {/* <EditProgressStepper
          formData={{
            deviceFormData,
            matchWith: {
              vehicle: vehicle?.id,
              relationId: currentMatch?.id,
            },
          }}
          steps={['Cihaz Bilgileri'
            // , 'Araçla Eşleştir'
          ]}
        > */}
        <>
          <div>
            <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
              {device_fields().map((field, index) => {
                return (
                  <div className=" flex w-full" key={index}>
                    <CustomInput
                      key={index}
                      type={field.type}
                      inputType={field.inputType}
                      defaultValue={field.defaultValue}
                      items={field.items}
                      label={field.placeHolder}
                      value={
                        deviceFormData !== undefined
                          ? deviceFormData[field.key]
                          : ''
                      }
                      fullWidth={true}
                      size={'small'}
                      onChange={(key, value) => {
                        setDeviceFormData({
                          ...deviceFormData,
                          [field.key]: value,
                        });
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </>
        {/* <>
            <div className="w-full">
              <div className="flex justify-center items-center">
                Güncel eşleşme: {currentMatch?.vehicle?.id}
              </div>
              <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
                <Autocomplete
                  fullWidth
                  options={vehicles}
                  getOptionLabel={(option) => option?.id}
                  onChange={(e, value) => {
                    setVehicle(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Araç Seçin"
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleFilterInput(e.target.value)}
                      value={filterData.query}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {isLoading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </> */}
        {/* </EditProgressStepper> */}
        <div className="flex justify-center items-center my-5">
          <Button
            fullWidth
            disabled={hash === '' || deviceFormData === undefined}
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            startIcon={<MATERIEL_ICONS.Save />}
          >
            Kaydet
          </Button>
        </div>
        {hash === '' ? (
          <div className="p-2 m-2  flex justify-center items-center">
            <span className="italic">Lütfen bir cihaz seçiniz.</span>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default CreateDeviceDrawer;
